import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "counter", "form"]

    connect() {
        this.timeout = null
        // Initial counter update
        this.updateResultsCounter()

        // Listen for Alpine.js filter changes
        this.element.addEventListener('integration-filter-changed', this.handleFilterChange.bind(this))
    }

    disconnect() {
        this.element.removeEventListener('integration-filter-changed', this.handleFilterChange.bind(this))
    }

    handleFilterChange(event) {
        // Trigger form submission when Alpine.js filters change
        this.perform()
    }

    perform() {
        clearTimeout(this.timeout)

        // Debounce search for 300ms to avoid too many requests
        this.timeout = setTimeout(() => {
            this.submitSearch()
        }, 300)
    }

    submitSearch() {
        // Get the form and submit it automatically
        if (this.hasFormTarget) {
            this.formTarget.requestSubmit()
        } else {
            // Fallback: find form via input target
            const form = this.inputTarget?.closest('form')
            if (form) {
                form.requestSubmit()
            } else {
                console.error('Stimulus: No form found to submit')
            }
        }
    }

    updateResultsCounter() {
        // Add a small delay to ensure DOM is updated
        setTimeout(() => {
            const cards = document.querySelectorAll('turbo-frame#integrations [data-integration-card]')

            if (this.hasCounterTarget) {
                const count = cards.length
                const text = `${count} integration${count !== 1 ? 's' : ''}`
                this.counterTarget.textContent = text
            } else {
                console.error('Stimulus: Counter target not found')
            }
        }, 100)
    }

    turboFrameLoaded() {
        this.updateResultsCounter()
    }

    clearSearch(event) {
        event.preventDefault()

        if (this.hasInputTarget) {
            this.inputTarget.value = ''
        }

        // Keep type filters, just clear search
        this.perform()
    }

    clearAllFilters(event) {
        event.preventDefault()

        if (this.hasInputTarget) {
            this.inputTarget.value = ''
        }

        // Clear Alpine.js multi-select
        const alpineElement = this.element.querySelector('[x-data]')
        if (alpineElement && alpineElement._x_dataStack) {
            const alpineData = alpineElement._x_dataStack[0]
            if (alpineData && typeof alpineData.clearAll === 'function') {
                alpineData.clearAll()
            }
        }

        this.perform()
    }
}